(function () {
  var DestinationColumnGenerator = function (batchGeoTable) {
    // this is sufficent to apply the destination column to the dataview
    // this function does not add this new column to the legend as a selectable group
    var generateColumn = function (dataArray) {
      var mapRS = batchGeoTable.options.data.mapRS;

      // from [{2: []}, {4: []}]
      // to [2, 4]
      var indicies = dataArray.map((row) => Number(Object.keys(row)[0]));

      batchGeoTable.addColumn(
        "Destination",
        mapRS.map(function (row, rowIndex) {
          // index of current mapRS item in dataArray
          let location = indicies.indexOf(rowIndex);
          if (location !== -1) {
            // if current mapRS item is in the dataArray
            return dataArray[location][indicies[location]][
              dataArray[location][indicies[location]].length - 1
            ][window.per.address_col]; //assumes last column
          }
          return "";
        }),
        batchGeoTable.data.columns.length,
      );

      batchGeoTable.render();
      window.batchGeoTableMap.updateTableHeight();
    };

    var removeColumn = function () {
      var destinationColumnIndex =
        batchGeoTable.data.columns.indexOf("Destination");
      batchGeoTable.removeColumn(destinationColumnIndex);
      batchGeoTable.render();
      window.batchGeoTableMap.updateTableHeight();
    };

    return {
      generateColumn: generateColumn,
      removeColumn: removeColumn,
    };
  };

  window.DestinationColumnGenerator = DestinationColumnGenerator;
})();
